import React from 'react'
const Toolbar: React.FunctionComponent = ({ children }) => (
  <div className="r w=full c=text elevated mb=3 flex align-center toolbar">{children}</div>
)

export default Toolbar
